import { fromJS, Map } from "immutable";
import { createSelector } from "reselect";

export default function reducer(state = {}, action) {
  switch (action.type) {
    case "APP/OPEN_MODAL":
      return {
        ...state,
        modal: action.payload
      };
    //return state.set("modal", fromJS(action.payload));

    case "APP/CLOSE_MODAL":
      return {
        ...state,
        modal: undefined
      };
    //return state.delete("modal");

    case "APP/ADD_FLASH_MESSAGE":
      return {
        ...state,
        flashMessage: action.payload
      };
    // return state.set("flashMessage", fromJS(action.payload));

    case "APP/REMOVE_FLASH_MESSAGE":
      return {
        ...state,
        flashMessage: null
      };
    //return state.delete("flashMessage");

    default: {
      const match = action.type.match(/(.*)_(LOADING|DONE)$/);
      if (match) {
        const newMap = {...state.loadingMap};
        if (match[2] === "LOADING") {
          newMap[match[1]] = true;
        } else {
          delete newMap[match[1]];
        }

        return {
          ...state,
          loadingMap: newMap
        };
      }
      else {
        return state;
      }
      // return match
      // ?state.setIn(["loading", match[1]], match[2] === "LOADING")
      //   : state;
    }
  }
}

const isRawModalClosed = (state) => {
  return state?.app?.modal;
};

export const isModalClosed = createSelector(
  [isRawModalClosed],
  (isModalClosed) => isModalClosed === undefined
);


export const getModalTitle = (state) => state?.app?.modal?.title;

export const getModalMessage = (state) => state?.app?.modal?.message;

export const getModalButtonLabel = (state) => state?.app?.modal?.buttonLabel;

export const getFlashMessageCode = (state) => state?.app?.flashMessage?.code;

const getRawLoadingApp = (state) => state?.app?.loadingMap;

const getLoadingMap = createSelector(
  [getRawLoadingApp],
  (loadingMap) => loadingMap ? fromJS(loadingMap) : Map()
);

export const isLoading = createSelector(
  [getLoadingMap, (_, props) => props.typePrefix],
  (loading, typePrefix) => loading.get(typePrefix, false)
);

export const getBlockingMessage = createSelector(
  [getLoadingMap, (_, props) => props.blockingActions],
  (loading, blockingActions = []) => {
    // List of action types that are currently loading
    const loadingTypes = Array.from(loading.entries()).filter(([, value]) => value).map(([key]) => key);

    // First entry in blockingActions object whose key matches a
    // loading action type
    const blockingAction = Object.entries(blockingActions).find(([key]) => loadingTypes.includes(key));

    return blockingAction ? blockingAction[1] : undefined;
  }
);
